export const ENV_GATSBY_SITE_URL = process.env.GATSBY_SITE_URL;
export const ENV_GATSBY_GOOGLE_ANALYTICS_KEY =
  process.env.GATSBY_GOOGLE_ANALYTICS_KEY;
export const ENV_GATSBY_BASE_URL = process.env.GATSBY_BASE_URL;
export const ENV_GATSBY_MATRIX_BASE_URL = process.env.GATSBY_MATRIX_BASE_URL;
export const ENV_GATSBY_DTC_UNIT = process.env.GATSBY_DTC_UNIT;

export const ENV_GENERIC_LL_SIGNUP_LINK = process.env.GATSBY_GENERIC_LL_SIGNUP_LINK
